import styles from "./hiddenContent.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeSlash } from "@fortawesome/pro-solid-svg-icons";

type BaseProps = {
  isHidden: boolean;
  variant: "list" | "card";
};

type ListProps = BaseProps & {
  variant: "list";
  showIcon?: boolean;
  children: React.ReactNode;
};

type CardProps = BaseProps & {
  variant: "card";
};

export type Props = ListProps | CardProps;

const HiddenListContent = ({ isHidden, showIcon, children }: Omit<ListProps, "variant">) => {
  if (!isHidden) {
    return children;
  }

  return (
    <div className={styles.hiddenListOverlay}>
      {showIcon && <FontAwesomeIcon icon={faEyeSlash} className={styles.icon} />}
      {children}
    </div>
  );
};

const HiddenCardContent = ({ isHidden }: Omit<CardProps, "variant">) => {
  if (!isHidden) {
    return null;
  }

  return (
    <div className={styles.hiddenCardOverlay}>
      <FontAwesomeIcon icon={faEyeSlash} className={styles.icon} />
    </div>
  );
};

export const HiddenContent = (props: Props) => {
  if (props.variant === "list") {
    return <HiddenListContent isHidden={props.isHidden} showIcon={props.showIcon} children={props.children} />;
  } else {
    return <HiddenCardContent isHidden={props.isHidden} />;
  }
};
